module.exports = __webpack_public_path__ + "static/media/CodeQuest4.0_Winners.69deee0d.jpeg";